/**
 * The authorization code and `state` must never reach history, a log, or an
 * analytics call — so /auth/google/callback's query string is read once and
 * replaced before anything renders. `captureAuthCallbackQuery()` is called
 * from main.tsx ahead of the React root, which is the last moment where
 * "before rendering" is still literally true.
 *
 * Google's response only ever reaches this app as a cookie plus a 302, so
 * there is no token here to leak — this is the belt to that braces, and it
 * also covers the failure redirect's `?error=` flag.
 */
export const authCallbackQuery: { error: string | null; next: string | null } = { error: null, next: null }

export const AUTH_CALLBACK_PATH = '/auth/google/callback'

export function captureAuthCallbackQuery(): void {
  if (window.location.pathname !== AUTH_CALLBACK_PATH) return
  const parameters = new URLSearchParams(window.location.search)
  authCallbackQuery.error = parameters.get('error')
  const next = parameters.get('next')
  // Same-origin paths only. Anything else is discarded and the screen falls
  // back to the destination it would have picked anyway.
  authCallbackQuery.next = next && next.startsWith('/') && !next.startsWith('//') ? next : null
  if (window.location.search || window.location.hash) {
    history.replaceState({}, '', AUTH_CALLBACK_PATH)
  }
}
